import { mediaData } from '@/mocks/comics';

export default function MediaSection() {
  return (
    <section id="media" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            精彩推荐
          </h2>
          <p className="text-sm text-foreground-500">
            编辑团队精选的热门漫画推荐
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaData.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group bg-background-50 rounded-xl border border-background-200 overflow-hidden hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block text-xs font-medium text-white bg-primary-500/90 px-3 py-1 rounded-full">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="inline-flex items-center gap-1 text-xs text-white/90 bg-foreground-900/60 px-2.5 py-1 rounded-full">
                    <i className="ri-time-line"></i>
                    {item.duration}
                  </span>
                </div>
              </div>

              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}